import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqData = [
  {
    question: "Who is doing the testing?",
    answer: (
      <>
        We're partnering with{" "}
        <a
          href="https://www.lightlabs.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-accent underline-offset-4 hover:underline"
        >
          Light Labs
        </a>{" "}
        to test all the products, and{" "}
        <a
          href="https://openlabelresearch.org"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-accent underline-offset-4 hover:underline"
        >
          OpenLabel Research Foundation
        </a>{" "}
        to facilitate testing and analysis.
      </>
    )
  },
  {
    question: "How does the testing process work?",
    answer: (
      <>
        You can read more about the Light Labs process{" "}
        <a
          href="https://www.lightlabs.com/lab"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-accent underline-offset-4 hover:underline"
        >
          here
        </a>
        .
      </>
    )
  },
  {
    question: "Was the formula powder diluted to simulate what babies actually drink in a serving?",
    answer: "Yes."
  },
  {
    question: "Where can I read Donately's payment policies and FAQ?",
    answer: (
      <>
        <a
          href="https://donately.com/frequently-asked-questions"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-accent underline-offset-4 hover:underline"
        >
          Here are their FAQs!
        </a>
      </>
    )
  },
  {
    question: "Are donations tax-deductible?",
    answer: "Not at the moment."
  },
  {
    question: "Where can I follow project updates?",
    answer: (
      <>
        <a
          href="https://twitter.com/JuliaLipton"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:text-accent underline-offset-4 hover:underline"
        >
          @JuliaLipton
        </a>{" "}
        will be tweeting updates along the way.
      </>
    )
  }
];

export const FAQ = () => {
  return (
    <motion.section
      id="faq"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="py-20 px-4 border-t border-border bg-white"
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10 space-y-4"
        >
          <h2 className="font-sans font-normal tracking-tight text-3xl md:text-4xl text-foreground">
            FAQ
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="w-full space-y-1">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-border"
              >
                <AccordionTrigger className="text-left font-normal text-foreground hover:no-underline py-6 text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-foreground pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </motion.section>
  );
};